import React from "react";
import { useTranslation } from "gatsby-plugin-react-i18next";
import { Stack, Typography, Divider } from "@mui/material";

const FooterBottom = () => {
  const { t } = useTranslation();

  return (
    <Stack gap="24px" pt={3} pb={0}>
      <Divider sx={{ borderTop: "1.5px solid rgba(255, 255, 255, 0.16)" }} />
      <Stack
        gap="24px"
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
      >
        <Typography color="white" variant="caption">
          2024 CBX | {t("footer.all_rights_reserved")} | {t("footer.legal")}
        </Typography>
        <Typography color="white" variant="caption">
          2745 Otay Pacific Drive, San Diego, California 92154
        </Typography>
      </Stack>
    </Stack>
  );
};

export default FooterBottom;
